const state = {
    financial_summaries: {
         
    }
}

export default state